import DialogBridge from 'bridges/dialogBridge';
export const UNDERAGE_CONSTANTS = {
  TIMING: {
    GUIDE_WAIT: 2000,
    FADE_DURATION: 500,
    DETECTION_TIMEOUT: 5000,
  },
  MESSAGES: {
    CANCEL_DIALOG: {
      getTitle: () => brsc.popup_confirm_stop,
      getDescription: () => brsc.delete_confirm_ex,
    },
  },
} as const;

export const showCancelDialog = (): Promise<boolean> => {
  return DialogBridge.open({
    title: UNDERAGE_CONSTANTS.MESSAGES.CANCEL_DIALOG.getTitle(),
    description: UNDERAGE_CONSTANTS.MESSAGES.CANCEL_DIALOG.getDescription(),
    cancelText: brsc.cancel,
    confirmText: brsc.confirm,
  });
};

export const handleCancelAndClose = (callback?: () => void) => {
  showCancelDialog().then((result: boolean) => {
    if (result) {
      Transition.clearNavigateAndHistory();
      BanManager.showModal({ banFlag: 5, pBanName: '', reason: '' });
      callback?.();
    }
  });
};

export const throttle = <T extends (...args: any[]) => any>(func: T, delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  let lastExecTime = 0;

  return (...args: Parameters<T>) => {
    const currentTime = Date.now();

    if (currentTime - lastExecTime > delay) {
      func(...args);
      lastExecTime = currentTime;
    } else {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(
        () => {
          func(...args);
          lastExecTime = Date.now();
        },
        delay - (currentTime - lastExecTime)
      );
    }
  };
};
